import React from 'react';
import { Alert, AlertTitle, Box, Chip, Container, Paper, Stack, Typography } from '@mui/material';

export default function ConfigErrorPage({ error }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        display: 'grid',
        placeItems: 'center',
        p: 3,
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={4} sx={{ p: { xs: 3, sm: 5 }, borderTop: '6px solid #b00020' }}>
          <Alert severity="error" variant="outlined">
            <AlertTitle>{error?.title || 'OEM configuration error'}</AlertTitle>
            {error?.message || 'The application configuration could not be loaded.'}
          </Alert>

          <Stack direction="row" spacing={1} sx={{ my: 3 }} useFlexGap flexWrap="wrap">
            <Chip label={`OEM: ${error?.oem || 'unknown'}`} />
            <Chip label={`Environment: ${error?.environment || 'unknown'}`} />
          </Stack>

          {error?.details?.length > 0 && (
            <Box component="ul" sx={{ pl: 3, mb: 3 }}>
              {error.details.map((detail) => (
                <Typography component="li" variant="body2" key={detail} sx={{ mb: 1 }}>
                  {detail}
                </Typography>
              ))}
            </Box>
          )}

          <Typography variant="body2" color="text.secondary">
            Check the container variables APP_OEM and APP_ENV, then restart this deployment.
            The application has stopped before contacting customer services.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
